// extracted by mini-css-extract-plugin
export default {"video_landing":"VideoModal_video_landing__Obf6P","promocode_content":"VideoModal_promocode_content__KRJ-E"};